import React from 'react';
import Notification from '../messagerie_user/notification';
import CotisationJoueur from './cotisationJoueur';
import CardAccueil from './cardAccueil';
import NavJoueur from '../navigation/navJoueur';

function ProfilJoueur(props) {

  return (
    <>
      <NavJoueur userData={props.userData} nom='Accueil'/>
      <div className="main profil_">
        <Notification userData = {props.userData}/>
        <CardAccueil nom={props.userData.user.donnée.results[0].nom_joueur} prenom={props.userData.user.donnée.results[0].prenom}/>
        <br/>
        <div className="card">
        <h2>Identité</h2>
          <div className="card-body">
            <table>
              <tbody>
                <tr>
                  <td>Nom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].nom_joueur}</td>
                </tr>
                <tr>
                  <td>Prénom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].prenom}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].email}</td>
                </tr>
                <tr>
                  <td>Numéro de téléphone</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].contact}</td>
                </tr>
                <tr>
                  <td>Poste</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].poste}</td>
                </tr>
                <tr>
                  <td>Numéro de maillot</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].numero}</td>
                </tr>
                <tr>
                  <td>Taille</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].taile} m</td>
                </tr>
                <tr>
                  <td>Poid</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].poid} kg</td>
                </tr>
                <tr>
                  <td>Pied fort</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].pied_fort}</td>
                </tr>
                <tr>
                  <td>Club</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].nom_equipe}</td>
                </tr>
                <tr>
                  <td>Adresse du club</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].adresse}</td>
                </tr>
                <tr>
                  <td>Catégorie</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].categorie}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br/>
          <hr></hr>
          <br/>
        <CotisationJoueur userData={props.userData}/>
        </div>
      </div>
    </>
  );
}

export default ProfilJoueur;
